export default "/assets/cfc4860c7030be51.png"